function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 018 8A8 8 0 110 8a8 8 0 018-8zm3.592 3C9.113 4.716 6.804 4.04 5.265 5.476c-.957.893-1.646 2.039-1.298 3.84l.153-.147c.757-.67 1.643-1.21 2.615-1.485a6.977 6.977 0 002.432-1.199 17.914 17.914 0 002.095-1.918 18.165 18.165 0 01-1.88 2.143C8.683 7.363 7.937 8.116 7 8.5c-.936.384-1.667.695-2.348 1.447-.68.763-1.26 1.593-1.652 2.646L4.332 13c.152-.653.473-1.341.866-1.971 1.57.865 3.274.24 4.302-.529 2.25-1.685 3.11-4.351 2.092-7.5z",
    fill: "#212A33",
    fillRule: "evenodd"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/badges/ic-badge-leaf.svg";